import { Dialog } from "@headlessui/react";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { WhiteLinearGradient } from "../../utils/Utils";
import CustomDialog from "../basic/Dialog";
import {
  createUserProgram,
  updateQuestions,
  updateUserProfile,
} from "../../api/api";
import { useAuthContext } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import {
  RegistrationStep1,
  RegistrationStep2,
  RegistrationStep3,
} from "../auth/Register";

function QuestionsDialog({ open, close }) {
  const auth = useAuthContext();
  const [height, setHeight] = useState(auth.state?.user?.height);
  const [weight, setWeight] = useState(auth.state?.user?.weight);
  const [gender, setGender] = useState(auth.state?.user?.gender);
  const [dob, setDob] = useState(
    auth.state.user?.dob
      ? new Date(
          auth.state.user.dob?.split("/")[2],
          auth.state.user.dob?.split("/")[1] - 1,
          auth.state.user.dob?.split("/")[0]
        )
      : null
  );
  const [heightUnit, setHeightUnit] = useState("cm");
  const [weightUnit, setWeightUnit] = useState("KG");
  const [step, setStep] = useState(0);
  const [workoutGoal, setWorkoutGoal] = useState([]);
  const [workoutDuration, setWorkoutDuration] = useState([0]);
  const [injuries, setInjuries] = useState([]);
  const [answers, setAnswers] = useState({
    workingOutFrom: "",
    lastWorkedOut: "",
    refer: "",
  });

  const navigate = useNavigate();

  async function updateData() {
    let data = {
      hasInjury: injuries.includes("none") ? 0 : 1,
      injuries: injuries.includes("none") ? [] : injuries,
      refer: answers.refer,
      lastWorkedOut: answers.lastWorkedOut,
      workingOutFrom: answers.workingOutFrom,
      workoutWeekDuration: workoutDuration[0],
      workoutGoal: workoutGoal,
    };
    await updateQuestions(data);
    data = {
      update: JSON.stringify({
        gender: gender,
        dob: dob
          .toLocaleString("en-us", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          })
          .replace(/(\d+)\/(\d+)\/(\d+)/, "$2/$1/$3"),
        height: height,
        weight: weight,
      }),
    };
    let response = await updateUserProfile(data);
    close();
    toast("Profile details updated");
    await createProgram();
    auth.updateUser();
  }

  const createProgram = async () => {
    setShowCurationDialog(true);

    let detials = {
      goals: JSON.stringify(workoutGoal),
      workingOutFrom: answers.workingOutFrom,
      lastTimeWorkedOut: answers.lastWorkedOut,
    };
    await createUserProgram(detials);
    await updateUserProfile({
      update: JSON.stringify({ firstLogin: "0" }),
    });
    auth.updateUser();
    setShowCurationDialog(false);
    // navigate("/exercise");
    navigate("/programpage");
    window.location.reload();
  };

  const [showCuratingDialog, setShowCurationDialog] = useState(false);

  useEffect(() => {
    if (auth.state.user) {
      setHeight(auth.state.user?.height);
      setWeight(auth.state.user?.weight);
      setGender(auth.state.user?.gender);
      setDob(
        auth.state.user?.dob
          ? new Date(
              auth.state.user.dob?.split("/")[2],
              auth.state.user.dob?.split("/")[1] - 1,
              auth.state.user.dob?.split("/")[0]
            )
          : null
      );
    }
  }, [auth.state?.user]);

  return (
    <CustomDialog show={open} close={close}>
      <Dialog.Panel
        className={`w-full md:max-w-2xl ${WhiteLinearGradient} rounded-xl`}
        id="register"
      >
        <div
          className={`w-full transform p-6 text-left align-middle transition-all space-y-5`}
        >
          <div
            as="h2"
            className="text-2xl font-medium text-left text-gray-900 dark:text-primary-white"
          >
            Basic Questions
          </div>
          {step == 0 && (
            <RegistrationStep1
              isRegister={false}
              setStep={setStep}
              height={height}
              setHeight={setHeight}
              weight={weight}
              setWeight={setWeight}
              dob={dob}
              setDob={setDob}
              heightUnit={heightUnit}
              setHeightUnit={setHeightUnit}
              weightUnit={weightUnit}
              setWeightUnit={setWeightUnit}
              gender={gender}
              setGender={setGender}
              onClickNext={() => {
                setStep(1);
              }}
              onClickBack={() => {
                setStep(0);
              }}
            />
          )}

          {step == 1 && (
            <RegistrationStep2
              describes={workoutGoal}
              setDescribes={setWorkoutGoal}
              onClickNext={() => {
                setStep(2);
              }}
              onClickBack={() => {
                setStep(0);
              }}
            />
          )}

          {step == 2 && (
            <RegistrationStep3
              answers={answers}
              setAnswers={setAnswers}
              injuries={injuries}
              setInjuries={setInjuries}
              workoutDuration={workoutDuration}
              setWorkoutDuration={setWorkoutDuration}
              onClickNext={() => {
                updateData();
              }}
              onClickBack={() => {
                setStep(1);
              }}
            />
          )}
        </div>
      </Dialog.Panel>
    </CustomDialog>
  );
}

export default QuestionsDialog;
